<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-message-question</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.qAndA') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
    </v-toolbar>
    <translate
      v-show="!collapseContent"
      v-model="content.QAndAQuestion"
      :languages="languages"
      :label="$t('qAndA.question')"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    />
    <small>{{$t('qAndA.answer')}}:</small>
    <translate
      v-show="!collapseContent"
      type="richText"
      v-model="content.QAndAAnswer"
      :languages="languages"
      :label="$t('qAndA.answer')"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    />
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import Translate from '@/components/Translate'
  export default {
    components: {
      Translate
    },
    props: {
      content: {
        type: Object,
        required: true
      }
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['collapseContent']),
      languages () {
        return this.$store.state.app.Languages
      }
    },
    mounted () {
    },
    methods: {
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      }
    }
  }
</script>

<style scoped>
</style>

